// src/utils/searchHistory.js
const KEY = "kupto_search_history_v1";

const safeJson = (value, fallback = []) => {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const normalizeTerm = (value) => String(value ?? "").trim();

const normalizeCompare = (value) => normalizeTerm(value).toLowerCase();

export const readSearchHistory = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = safeJson(raw || "[]", []);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

export const pushSearchHistory = (q, { max = 20 } = {}) => {
  const term = normalizeTerm(q);
  if (!term) return;

  const list = readSearchHistory();
  const norm = normalizeCompare(term);

  const next = [
    { q: term, at: Date.now() },
    ...list.filter((x) => normalizeCompare(x?.q) !== norm),
  ].slice(0, Math.max(1, Number(max) || 20));

  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    return;
  }

  // notify UI
  window.dispatchEvent(new Event("searchHistoryUpdated"));
};

export const removeSearchHistoryItem = (q) => {
  const term = normalizeTerm(q);
  if (!term) return;

  const norm = normalizeCompare(term);
  const list = readSearchHistory();

  const next = list.filter((x) => normalizeCompare(x?.q) !== norm);

  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    return;
  }

  window.dispatchEvent(new Event("searchHistoryUpdated"));
};

export const clearSearchHistory = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    return;
  }

  window.dispatchEvent(new Event("searchHistoryUpdated"));
};